import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { toRefs } from 'vue';
import { Swiper, SwiperSlide } from 'swiper/vue';
import SlideItem from './SlideItem.vue';
import { Pagination } from 'swiper/modules';
import { useWindowSize } from '@vueuse/core';
import { useGlobalStore } from '@/stores/global';
import { useRouter } from 'vue-router';
import 'swiper/css';
import 'swiper/css/scrollbar';


export default /*#__PURE__*/_defineComponent({
  __name: 'Slider',
  setup(__props) {

const router = useRouter();

const globalStore = useGlobalStore();
const { excursions } = toRefs(globalStore);

const { width } = useWindowSize();

return (_ctx: any,_cache: any) => {
  return (_unref(excursions))
    ? (_openBlock(), _createBlock(_unref(Swiper), {
        key: 0,
        slidesPerView: _unref(width) >= 768 ? 2.5 : 'auto',
        spaceBetween: 24,
        pagination: "",
        modules: [_unref(Pagination)],
        "grab-cursor": ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(excursions)?.data, (slide, i) => {
            return (_openBlock(), _createBlock(_unref(SwiperSlide), { key: i }, {
              default: _withCtx(() => [
                _createVNode(SlideItem, {
                  text: slide.attributes.subtitle,
                  title: slide.attributes.title,
                  price: slide.attributes.summForGroup,
                  url: slide.attributes.img.data?.attributes.url,
                  id: slide.id,
                  onClick: ($event: any) => (
                    _unref(router).push({
                        name: 'excursion',
                        params: { id: slide.id },
                    })
                )
                }, null, 8, ["text", "title", "price", "url", "id", "onClick"])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["slidesPerView", "modules"]))
    : _createCommentVNode("", true)
}
}

})